import { clearEmptyErrors } from '@shared/lib/validation/clearEmptyErrorsValidation/clear-empty-errors';
import { EditFormKeys } from '../config/form-constants';
import { EditFormFields } from '../ui/modal-edit-user/types';
import { required } from '@shared/lib/validation/validateRequired/required';

export const validate = (fields: EditFormFields) => {
    const errors = {} as Record<EditFormKeys, string>;
    errors[EditFormKeys.Role] = required(fields[EditFormKeys.Role]);
    return clearEmptyErrors(errors);
};
